export const actionCase = {
  mobile: "mobile",
  email: "email",
};

export const name = "PcwRegistration";
export const constants = {
  name,
};
